<template>
    <b-modal
        id="modalChangePassword"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        modal-class="modal-dark"
        centered
        title="Atualização de senha"
        hide-footer
        @hide="handleClose"
    >
        <b-card-text>
            <validation-observer
                ref="changePassword"
                #default="{invalid}"
            >
                <b-form @submit.prevent="changePassword">
                    <b-row class="auth-login-form mt-2">
                        <b-col class="col-md-12">
                            <b-form-group
                                label-for="password"
                                label="Senha"
                            >
                                <validation-provider
                                    #default="{ errors }"
                                    name="password"
                                    rules="required|password:@checkPassword"
                                >
                                    <b-input-group
                                        class="input-group-merge"
                                        :class="errors.length > 0 ? 'is-invalid':null"
                                    >
                                        <b-form-input
                                            id="password"
                                            v-model="password"
                                            :type="passwordFieldType"
                                            class="form-control-merge"
                                            :state="errors.length > 0 ? false:null"
                                            name="password"
                                            placeholder="Senha"
                                        />

                                        <b-input-group-append is-text>
                                            <feather-icon
                                                class="cursor-pointer"
                                                :icon="passwordToggleIcon"
                                                @click="togglePasswordVisibility"
                                            />
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-md-12">
                            <b-form-group
                                label-for="checkPassword"
                                label="Repita a senha"
                            >
                                <validation-provider
                                    #default="{ errors }"
                                    name="checkPassword"
                                    rules="required"
                                >
                                    <b-input-group
                                        class="input-group-merge"
                                        :class="errors.length > 0 ? 'is-invalid':null"
                                    >
                                        <b-form-input
                                            id="checkPassword"
                                            v-model="checkPassword"
                                            :type="passwordFieldType"
                                            class="form-control-merge"
                                            :state="errors.length > 0 ? false:null"
                                            name="checkPassword"
                                            placeholder="Repita senha"
                                        />

                                        <b-input-group-append is-text>
                                            <feather-icon
                                                class="cursor-pointer"
                                                :icon="passwordToggleIcon"
                                                @click="togglePasswordVisibility"
                                            />
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-md-12 mt-3">
                            <b-button
                                variant="dark"
                                type="submit"
                                block
                                :disabled="loading"
                            >
                                <b-spinner small type="grow" label="Loading..." v-if="loading"></b-spinner>
                                <span v-else>Definir nova senha</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </b-card-text>
    </b-modal>
</template>

<script>

import { togglePasswordVisibility } from '@core/mixins/ui/forms'

import ToastificationContent from "@core/components/toastification/ToastificationContent";
import LoginService from "@/services/LoginService";

export default {
    name: "RefreshPassword",
    mixins:[togglePasswordVisibility],
    props:{
        id:{
            type: Number,
            required: true,
        }
    },
    mounted() {
        this.$bvModal.show('modalChangePassword');
    },
    data() {
        return {
            loading: false,
            password: null,
            checkPassword: null,
        }
    },
    computed:{
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
    },
    methods:{
        changePassword() {
            this.$refs.changePassword.validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    LoginService.changePassword(this.id, this.password).then(resp => {
                        this.$toast({
                                component: ToastificationContent,
                                props: {
                                    title: 'Sucesso!',
                                    icon: 'BellIcon',
                                    text: resp.data.message,
                                    variant: 'info',
                                },
                            },
                            {
                                position: 'top-center'
                            });
                        this.loading = false;
                        this.handleClose(true);
                    }).catch(err => {
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: 'Oops!',
                                icon: 'BellIcon',
                                text: err.response.data.message,
                                variant: 'danger',
                            },
                        },
                        {
                            position: 'top-center'
                        });

                        this.loading = false;
                    });
                }
            })
        },
        handleClose(passwordChanged = false) {
            this.$emit('closedModal', {passwordChanged: passwordChanged})
        }
    }
}
</script>

<style scoped>

</style>